import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  transition: transform 0.2s ease-in-out;\n  transform: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { Box, Text } from "@miro-site/core";
import { Expand } from "../icons/Icons";
var Header = function(_param) {
    var children = _param.children, isExpanded = _param.isExpanded, props = _object_without_properties(_param, [
        "children",
        "isExpanded"
    ]);
    return /*#__PURE__*/ _jsxs(HeaderStyled, _object_spread_props(_object_spread({
        $variant: "p0",
        as: "div"
    }, props), {
        children: [
            children,
            /*#__PURE__*/ _jsx(Icon, {
                $isExpanded: isExpanded,
                children: /*#__PURE__*/ _jsx(Expand, {})
            })
        ]
    }));
};
var Icon = styled(Box).withConfig({
    componentId: "sc-bd575d2e-0"
})(_templateObject(), function(props) {
    return props.$isExpanded ? "rotate(180deg)" : "rotate(0deg)";
});
var HeaderStyled = styled(Text).attrs({
    $variant: "p1",
    $styles: {
        height: [
            84,
            null,
            null,
            null
        ]
    }
}).withConfig({
    componentId: "sc-bd575d2e-1"
})(_templateObject1());
export default Header;
